import React, { useCallback, useEffect, useRef, useState } from "react";
import { Navbar } from "../Components/Common/Navbar/Navbar";
import { ProgressBar } from "../Components/Common/UI/ProgressBar/ProgressBar";
import { PatientParticulars } from "../Components/Forms/PatientParticulars";
import { submitQuestionary, getQuestionaryByAppointmentId } from "../API/question";
import { loadFormDraft, saveFormDraft, clearFormDraft } from "../utils/formStorage";
import { normalizeInvestigationFieldFromApi } from "../utils/investigationFiles";
import {
  NextButton,
  PreviousButton,
} from "../Components/Common/UI/NavBtns/NavBtns";
import { PainLocation } from "../Components/Forms/PainLocation";
import { PainSeverity } from "../Components/Forms/PainSeverity";
import { OriginOfPain } from "../Components/Forms/OriginOfPain";
import { PainCharacteristics } from "../Components/Forms/PainCharacteristics";
import { Relivingfactors } from "../Components/Forms/Relivingfactors";
import { AssociatedSymptoms } from "../Components/Forms/AssociatedSymptoms";
import { DisabilityPain } from "../Components/Forms/DisabilityPain";
import { FunctionalScoring } from "../Components/Forms/FunctionalScoring";
import { MedicationForPain } from "../Components/Forms/MedicationForPain";
import { PainHistory } from "../Components/Forms/PainHistory";
import { PainHistory2 } from "../Components/Forms/PainHistory2";
import { PainHistory3 } from "../Components/Forms/PainHistory3";
import { PainHistory4 } from "../Components/Forms/PainHistory4";
import { InvestigationsHistory } from "../Components/Forms/InvestigationsHistory";
import { CurrentMedications } from "../Components/Forms/CurrentMedications";
import { PastMedicalHistory } from "../Components/Forms/PastMedicalHistory";
import { PastMedicalHistory2 } from "../Components/Forms/PastMedicalHistory2";
import { ReviewOfSystems } from "../Components/Forms/ReviewOfSystems";
import { SocialHistory } from "../Components/Forms/SocialHistory";

import { ChoosePainLevel } from "../Components/Forms/ChoosePainLevel";
import { useNavigate, useParams } from "react-router-dom";
import CellParttenBg from "../assets/images/CellPatternBg2.png";
import { motion } from "framer-motion";
import {
  CurrentMedicationIcon,
  DisablilityPainIcon,
  FunctionalScoringIcon,
  InvestigationsHistoryIcon,
  MedicationForPainIcon,
  OriginOfPainIcon,
  PainCharacteristicsIcon,
  PainLevel,
  PainLocationIcon,
  PainTreatmentHistoryIcon,
  PastMedicalHistoryIcon,
  PatientParticularsIcon,
  RelivingFactorIcon,
  SocialHistoryIcon,
  SymptomsIcon,
  SystemForTodayIcon,
} from "../assets/Allsvgs";
import { Menu, X } from "lucide-react";

export const Homepage = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isOpen, setIsOpen] = useState({
    tabName: "",
    state: false,
  });
  const elementRef = useRef(null);
  const [screenshot, setScreenshot] = useState(null);
  const [selectedLoaction, setSelectedLocation] = useState([]);
  const [selectedLoactionMulti, setSelectedLocationMulti] = useState([]);
  const [selectedPainLocation, setSelectedPainLocation] = useState({
    painLocation: "",
    cameraPosition: [5, 10, 10],
    distance: 5.5,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const router = useNavigate();
  const { id } = useParams();

  const [patientMedicationInfo, setPatientMedicationInfo] = useState({
    firstName: "",
    lastName: "",
    age: "",
    height: "0",
    weight: "0",
    selectedPainArea: [],
    /** Unused — per-area intensity lives on selectedPainArea[].painLevel (ChoosePainLevel) */
    selectedPainIntensity: "",
    whenPainBegin: "",
    whenPainBeginMonths: "",
    currentPainEpisode: "",
    currentPainEpisodeBegin: "",
    painBeganHowChanged: "",
    describeYourPain: "",
    painWrostTime: "",
    painOccurs: "",
    changesInWeather: "",
    driving: "",
    liftingObjects: "",
    standing: "",
    climbingStairs: "",
    risingFromSitting: "",
    walking: "",
    coughingSneezing: "",
    sitting: "",
    bendingBackward: "",
    bendingForward: "",
    lookingUpward: "",
    lookingDownward: "",
    otherRelievingFactor: "",
    otherRelievingFactorText: "",
    disabilityDueToPain: "",
    numbnessTingling: [],
    weaknessInNeck: [],
    weaknessInLegs: "",
    joinSwellingStiffness: [],
    feverChills: "",
    otherAssociatedSymptoms: "",
    morningStiffnessInBack: "",
    lossOfBladderControl: "",
    lossOfBowelControl: "",
    balanceRelatedProblems: "",
    timeYouCanStandInOneLocation: "",
    timeYouCanWalkWithoutPain: "",
    isWalkingLimited: "",
    painIntensity: "",
    personalCare: "",
    socialLife: "",
    travelling: "",
    employmentHomemaking: "",
    sittingInFS: "",
    standingInFS: "",
    sleepingInFS: "",
    liftingInFS: "",
    walkingInFS: "",
    functionalScore: 0,
    functionalScorePercentage: 0,
    doTakeMedicationForPain: "",
    medicationForPainList: [],
    hadTeatmentForPain: "",
    spineSurgery: "",
    psychologicalTherapy: "",
    hotColdPack: "",
    tensUnit: "",
    physicalTherapy: "",
    branchSupport: "",
    massageTherapy: "",
    spinalCordStimulator: "",
    chiropracticCare: "",
    acupuncture: "",
    medication: "",
    spinalCordStimulatorImplant: "",
    PTHOther: "",
    limitedForPain: "",
    isTherapyhelp: "",
    specialExercisesName: "",
    pastSurgicalHistory: "",
    pastMedicationInfo: [],
    mriInfo: {
      region: "",
      date: "",
      isUploaded: "",
    },
    ctScan: {
      region: "",
      date: "",
      isUploaded: false,
    },
    EMGNCV: {
      region: "",
      date: "",
      isUploaded: false,
    },
    xRay: {
      region: "",
      date: "",
      isUploaded: false,
    },
    vascularStudies: {
      region: "",
      date: "",
      isUploaded: false,
    },
    dexaScan: {
      region: "",
      date: "",
      isUploaded: false,
    },
    myelogram: {
      region: "",
      date: "",
      isUploaded: false,
    },
    discogram: {
      region: "",
      date: "",
      isUploaded: false,
    },
    petScan: {
      region: "",
      date: "",
      isUploaded: false,
    },

    otherDiagnosticTesting: "",
    otherDiagnosticTestingDate: "",
    noDiagnosticTests: false,
    haveImageToUpload: "",
    acupuncturist: {
      name: "",
      treatment: "",
      painRelief: "",
      date: "",
      isUploaded: false,
    },
    neurosurgeon: {
      name: "",
      treatment: "",
      painRelief: "",
      date: "",
      isUploaded: false,
    },
    chiropractor: {
      name: "",
      treatment: "",
      painRelief: "",
      date: "",
      isUploaded: false,
    },
    orthopedicSurgeon: {
      name: "",
      treatment: "",
      painRelief: "",
      date: "",
      isUploaded: false,
    },
    rheumatologist: {
      name: "",
      treatment: "",
      painRelief: "",
      date: "",
      isUploaded: false,
    },
    internist: {
      name: "",
      treatment: "",
      painRelief: "",
      date: "",
      isUploaded: false,
    },
    physicalTherapist: {
      name: "",
      treatment: "",
      painRelief: "",
      date: "",
      isUploaded: false,
    },
    neurologist: {
      name: "",
      treatment: "",
      painRelief: "",
      date: "",
      isUploaded: false,
    },
    psychiatrist: {
      name: "",
      treatment: "",
      painRelief: "",
      date: "",
      isUploaded: false,
    },
    namePreviousPain: "",
    physiciansHaveSeen: "",
    takingBloodThinner: "",
    nameBloodThinner: "",
    currentMedicationInfo: [],
    haveYouEveryDiagnosed: "",
    dementiaAlzheimers: "",
    pregnant: "",
    cancerType: "",
    diabetesType: "",
    diabetesControlled: "",
    bloodSugarWeekly: "",
    HBALC: "",
    diabetesComorbidity: "",
    medicationAllergies: "",
    medicationAllergiesText: "",
    headEarsEyesNoseThroat: [],
    hematologic: [],
    musculoskeletalRheumatologic: [],
    cardiovascular: [],
    respiratory: [],
    gastrointestinal: [],
    neuropsychological: [],
    urological: [],
    general: [],
    respiratoryReview: [],
    gastrointestinalReview: [],
    musculoskeletalReview: [],
    genitourinaryNephrology: [],
    neurologicalReview: [],
    psychiatricReview: [],
    constitutional: [],
    ENT: [],
    eyes: [],
    allOtherReviewNegative: "",
    allOtherReviewNegativeText: "",
    relationshipStatus: "",
    NoOfChildrens: "",
    occupation: "",
    lastTimeWorked: "",
    currentHousehold: "",
    stairsInHouse: "",
    employmentDisability: "",
    employmentDisabilityDateStarted: "",
    alcoholUse: "",
    tobaccoUse: "",
    tobaccoUseYears: "",
    tobaccoUsePacksPerDay: "",
    tobaccoUseQuitDate: "",
    illegalDrugUse: "",
    illegalDrugUseDetails: "",
    prescriptionNarcoticAbuse: "",
    transfusionGraftHistory: [],
    familyHistory: [],
    familyHistoryOtherText: "",
    MRI_FILE: [],
    CT_SCAN_FILE: [],
    X_RAYS_FILE: [],
    EMG_NCV_FILE: [],
    VASCULAR_STUDIES_FILE: [],
    DEXA_SCAN_FILE: [],
    MYELOGRAM_FILE: [],
    DISCOGRAM_FILE: [],
    PET_SCAN_FILE: [],
    acupuncturist_FILE: [],
    neurosurgeon_FILE: [],
    chiropractor_FILE: [],
    orthopedic_FILE: [],
    rheumatologist_FILE: [],
    internist_FILE: [],
    physical_FILE: [],
    neurologist_FILE: [],
    psychiatrist_FILE: [],
  });

  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [isFormLocked, setIsFormLocked] = useState(false);
  const isFormLockedRef = useRef(false);

  useEffect(() => {
    isFormLockedRef.current = isFormLocked;
  }, [isFormLocked]);

  const guardedSetPatientMedicationInfo = useCallback((update) => {
    if (isFormLockedRef.current) return;
    if (typeof update === "function") {
      setPatientMedicationInfo((prev) => {
        if (isFormLockedRef.current) return prev;
        return update(prev);
      });
    } else {
      setPatientMedicationInfo(update);
    }
  }, []);

  const guardedSetSelectedLocation = useCallback((update) => {
    if (isFormLockedRef.current) return;
    if (typeof update === "function") {
      setSelectedLocation((prev) => {
        if (isFormLockedRef.current) return prev;
        return update(prev);
      });
    } else {
      setSelectedLocation(update);
    }
  }, []);

  const guardedSetSelectedLocationMulti = useCallback((update) => {
    if (isFormLockedRef.current) return;
    if (typeof update === "function") {
      setSelectedLocationMulti((prev) => {
        if (isFormLockedRef.current) return prev;
        return update(prev);
      });
    } else {
      setSelectedLocationMulti(update);
    }
  }, []);

  const guardedSetScreenshot = useCallback((update) => {
    if (isFormLockedRef.current) return;
    if (typeof update === "function") {
      setScreenshot((prev) => {
        if (isFormLockedRef.current) return prev;
        return update(prev);
      });
    } else {
      setScreenshot(update);
    }
  }, []);

  const guardedSetSelectedPainLocation = useCallback((update) => {
    if (isFormLockedRef.current) return;
    if (typeof update === "function") {
      setSelectedPainLocation((prev) => {
        if (isFormLockedRef.current) return prev;
        return update(prev);
      });
    } else {
      setSelectedPainLocation(update);
    }
  }, []);

  const allForms = [
    {
      id: 1,
      title: `Enter Patient Particulars`,
      subtitle: `Please Enter patient Details`,
    },
    {
      id: 2,
      title: `Pain Location`,
      subtitle: `Point out or Select the area of pain.`,
    },
    {
      id: 3,
      title: `Choose Pain Level`,
      subtitle: `Select Your Preferred Intensity`,
    },
    {
      id: 4,
      title: `Origin of the pain`,
      subtitle: `Enter Details when did the pain began `,
    },
    {
      id: 5,
      title: `Pain Characteristics`,
      subtitle: `Enter Details About the characteristics of the Pain.`,
    },
    {
      id: 6,
      title: `Aggravating and relieving factors for pain `,
      subtitle: `Enter aggravating and relieving factors  of the Pain.`,
    },
    {
      id: 7,
      title: `Associated Symptoms`,
      subtitle: `Identify Related Symptoms.`,
    },
    {
      id: 8,
      title: `Disability due to pain`,
      subtitle: `Enter Disabilities caused because of the Pain.`,
    },
    {
      id: 9,
      title: `Functional Scoring`,
      subtitle: `Evaluate how your condition impacts daily activities with our functional scoring system. This assessment helps measure limitations in movement, strength, and overall functionality, providing valuable insights for treatment planning. Select the most accurate responses to ensure a precise evaluation of your functional abilities and progress over time.`,
    },
    {
      id: 10,
      title: `Medications for pain`,
      subtitle: `Enter Medication your are taking.`,
    },
    {
      id: 11,
      title: `Pain Treatment History`,
      subtitle: `Document your history of pain treatments, including medications, therapies, and interventions. Understanding what has worked—or hasn’t—helps guide better treatment decisions. Provide details on previous approaches, their effectiveness, and any side effects to ensure a personalized and effective pain management plan moving forward.`,
    },
    {
      id: 12,
      title: `Pain Treatment History`,
      subtitle: `Document your history of pain treatments, including medications, therapies, and interventions. Understanding what has worked—or hasn’t—helps guide better treatment decisions. Provide details on previous approaches, their effectiveness, and any side effects to ensure a personalized and effective pain management plan moving forward.`,
    },
    {
      id: 13,
      title: `Pain Treatment History`,
      subtitle: `Document your history of pain treatments, including medications, therapies, and interventions. Understanding what has worked—or hasn’t—helps guide better treatment decisions. Provide details on previous approaches, their effectiveness, and any side effects to ensure a personalized and effective pain management plan moving forward.`,
    },
    {
      id: 14,
      title: `Investigations History`,
      subtitle: `Review and document all medical investigations related to your condition, including X-rays, MRIs, blood tests, and other diagnostic procedures. Understanding your past test results helps in making informed decisions about future care and treatment. Provide details on findings and their impact on your diagnosis and treatment plan.`,
    },
    {
      id: 15,
      title: `Investigations History`,
      subtitle: `Review and document all medical investigations related to your condition, including X-rays, MRIs, blood tests, and other diagnostic procedures. Understanding your past test results helps in making informed decisions about future care and treatment. Provide details on findings and their impact on your diagnosis and treatment plan.`,
    },
    {
      id: 16,
      title: `Current Medications`,
      subtitle: `Document all medications you are currently taking, including prescriptions, over-the-counter drugs, and supplements. Providing accurate details about dosages and frequency helps ensure safe and effective treatment. This information is essential for avoiding drug interactions and optimizing your pain management plan`,
    },
    {
      id: 17,
      title: `Past Medical History`,
      subtitle: `Provide details of any past medical conditions, surgeries, or chronic illnesses that may impact your current health. Understanding your medical history helps in creating a more effective treatment plan and identifying potential risk factors related to your condition.`,
    },

    {
      id: 18,
      title: `Review of systems for today`,
      subtitle: `Evaluate your current health status by reviewing symptoms across different body systems. This helps identify any new or ongoing issues that may require attention. Providing a detailed overview ensures a comprehensive assessment and aids in accurate diagnosis and treatment planning.`,
    },
    {
      id: 19,
      title: `Social History`,
      subtitle: `Share details about your daily habits, occupation, living situation, and social support system. Factors such as smoking, alcohol use, physical activity, and stress levels can impact your overall well-being and treatment outcomes. Understanding your social history helps create a personalized and effective healthcare plan.`,
    },
  ];

  const handleNext = () => {
    if (currentStep < allForms.length) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep >= 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  //   render current form...
  const renderCurrentForm = () => {
    switch (currentStep) {
      case 0:
        return (
          <PatientParticulars
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 1:
        return (
          <PainLocation
            setSelectedPainLocation={guardedSetSelectedPainLocation}
            elementRef={elementRef}
            setScreenshot={guardedSetScreenshot}
            setSelectedLocationMulti={guardedSetSelectedLocationMulti}
            selectedLoactionMulti={selectedLoactionMulti}
            screenshot={screenshot}
            selectedLoaction={selectedLoaction}
            setSelectedLocation={guardedSetSelectedLocation}
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 2:
        return (
          <ChoosePainLevel
            screenShotImg={screenshot}
            selectedPainLocation={selectedPainLocation}
            selectedLoactionMulti={selectedLoactionMulti}
            setSelectedLocationMulti={guardedSetSelectedLocationMulti}
            patientMedicationInfo={patientMedicationInfo}
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
          />
        );
      // case 3:
      //   return <PainSeverity selectedPainLocation={selectedPainLocation} />;
      case 3:
        return (
          <OriginOfPain
            selectedPainLocation={selectedPainLocation}
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 4:
        return (
          <PainCharacteristics
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 5:
        return (
          <Relivingfactors
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 6:
        return (
          <AssociatedSymptoms
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 7:
        return (
          <DisabilityPain
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 8:
        return (
          <FunctionalScoring
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 9:
        return (
          <MedicationForPain
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 10:
        return (
          <PainHistory
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 11:
        return (
          <PainHistory2
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 12:
        return (
          <PainHistory3
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 13:
        return (
          <PainHistory4
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 14:
        return (
          <InvestigationsHistory
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 15:
        return (
          <CurrentMedications
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 16:
        return (
          <PastMedicalHistory
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      // case 17:
      //   return (
      //     <PastMedicalHistory2
      //       setPatientMedicationInfo={guardedSetPatientMedicationInfo}
      //       patientMedicationInfo={patientMedicationInfo}
      //     />
      //   );
      case 17:
        return (
          <ReviewOfSystems
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
      case 18:
        return (
          <SocialHistory
            setPatientMedicationInfo={guardedSetPatientMedicationInfo}
            patientMedicationInfo={patientMedicationInfo}
          />
        );
    }
  };

  const [progress, setProgress] = useState(0);

  // Calculate progress based on filled fields

  useEffect(() => {
    const isValueFilled = (value) => {
      if (value === "" || value === null) return false;

      // Handle arrays
      if (Array.isArray(value)) return value.length > 0;

      // Handle objects (like your nested scans)
      if (typeof value === "object") {
        return Object.values(value).some((v) => v !== "" && v !== null);
      }

      // Handle everything else (string, number, boolean)
      return true;
    };

    const totalFields = Object.keys(patientMedicationInfo).length;
    const filledFields = Object.values(patientMedicationInfo).filter(
      isValueFilled
    ).length;

    const progressPercentage = (filledFields / totalFields) * 100;
    setProgress(progressPercentage);
  }, [patientMedicationInfo]);

  useEffect(() => {
    const fetchExistingFormData = async () => {
      if (!id) {
        // No appointment in URL — keep empty initial state (do not load unrelated drafts)
        return;
      }

      try {
        // Fetch from API first (saved questionnaire on server)
        const existingData = await getQuestionaryByAppointmentId(id);
        
        if (existingData) {
          const loadedPainAreas = Array.isArray(existingData.selectedPainArea)
            ? existingData.selectedPainArea
            : [];
          const toMultiSelect = (v) =>
            Array.isArray(v) ? v : v != null && v !== "" ? [String(v)] : [];

          // Map API data to state structure
          setPatientMedicationInfo({
            firstName: existingData.firstName || "",
            lastName: existingData.lastName || "",
            age: existingData.age || "",
            height: existingData.height || "0",
            weight: existingData.weight || "0",
            selectedPainArea: loadedPainAreas,
            selectedPainIntensity: existingData.selectedPainIntensity || "",
            whenPainBegin: existingData.whenPainBegin || "",
            whenPainBeginMonths: existingData.whenPainBeginMonths || "",
            currentPainEpisode: existingData.currentPainEpisode || "",
            currentPainEpisodeBegin: existingData.currentPainEpisodeBegin || "",
            painBeganHowChanged: existingData.painBeganHowChanged || "",
            describeYourPain: Array.isArray(existingData.describeYourPain) ? existingData.describeYourPain : (existingData.describeYourPain || ""),
            painWrostTime: Array.isArray(existingData.painWrostTime) ? existingData.painWrostTime : (existingData.painWrostTime || ""),
            painOccurs: existingData.painOccurs || "",
            changesInWeather: existingData.changesInWeather || "",
            driving: existingData.driving || "",
            liftingObjects: existingData.liftingObjects || "",
            standing: existingData.standing || "",
            climbingStairs: existingData.climbingStairs || "",
            risingFromSitting: existingData.risingFromSitting || "",
            walking: existingData.walking || "",
            coughingSneezing: existingData.coughingSneezing || "",
            sitting: existingData.sitting || "",
            bendingBackward: existingData.bendingBackward || "",
            bendingForward: existingData.bendingForward || "",
            lookingUpward: existingData.lookingUpward || "",
            lookingDownward: existingData.lookingDownward || "",
            otherRelievingFactor: existingData.otherRelievingFactor || "",
            otherRelievingFactorText: existingData.otherRelievingFactorText || "",
            disabilityDueToPain: existingData.disabilityDueToPain || "",
            numbnessTingling: toMultiSelect(existingData.numbnessTingling),
            weaknessInNeck: toMultiSelect(existingData.weaknessInNeck),
            weaknessInLegs: existingData.weaknessInLegs || "",
            joinSwellingStiffness: toMultiSelect(
              existingData.joinSwellingStiffness
            ),
            feverChills: existingData.feverChills || "",
            morningStiffnessInBack: existingData.morningStiffnessInBack || "",
            lossOfBladderControl: existingData.lossOfBladderControl || "",
            lossOfBowelControl: existingData.lossOfBowelControl || "",
            balanceRelatedProblems: existingData.balanceRelatedProblems || "",
            timeYouCanStandInOneLocation: existingData.timeYouCanStandInOneLocation || "",
            timeYouCanWalkWithoutPain: existingData.timeYouCanWalkWithoutPain || "",
            isWalkingLimited: existingData.isWalkingLimited || "",
            painIntensity: existingData.painIntensity || "",
            personalCare: existingData.personalCare || "",
            socialLife: existingData.socialLife || "",
            travelling: existingData.travelling || "",
            employmentHomemaking: existingData.employmentHomemaking || "",
            sittingInFS: existingData.sittingInFS || "",
            standingInFS: existingData.standingInFS || "",
            sleepingInFS: existingData.sleepingInFS || "",
            liftingInFS: existingData.liftingInFS || "",
            walkingInFS: existingData.walkingInFS || "",
            functionalScore: existingData.functionalScore || 0,
            functionalScorePercentage: existingData.functionalScorePercentage || 0,
            doTakeMedicationForPain: existingData.doTakeMedicationForPain || "",
            medicationForPainList: existingData.medicationForPainList || [],
            hadTeatmentForPain: existingData.hadTeatmentForPain || "",
            spineSurgery: existingData.spineSurgery || "",
            psychologicalTherapy: existingData.psychologicalTherapy || "",
            hotColdPack: existingData.hotColdPack || "",
            tensUnit: existingData.tensUnit || "",
            physicalTherapy: existingData.physicalTherapy || "",
            branchSupport: existingData.branchSupport || "",
            massageTherapy: existingData.massageTherapy || "",
            spinalCordStimulator: existingData.spinalCordStimulator || "",
            chiropracticCare: existingData.chiropracticCare || "",
            acupuncture: existingData.acupuncture || "",
            medication: existingData.medication || "",
            spinalCordStimulatorImplant: existingData.spinalCordStimulatorImplant || "",
            PTHOther: existingData.PTHOther || "",
            limitedForPain: existingData.limitedForPain || "",
            isTherapyhelp: existingData.isTherapyhelp || "",
            specialExercisesName: existingData.specialExercisesName || "",
            pastSurgicalHistory: existingData.pastSurgicalHistory || "",
            pastMedicationInfo: existingData.pastMedicationInfo || [],
            mriInfo: { region: "", date: "", isUploaded: "", ...(existingData.mriInfo || {}) },
            ctScan: { region: "", date: "", isUploaded: false, ...(existingData.ctScan || {}) },
            EMGNCV: { region: "", date: "", isUploaded: false, ...(existingData.EMGNCV || {}) },
            xRay: { region: "", date: "", isUploaded: false, ...(existingData.xRay || {}) },
            vascularStudies: { region: "", date: "", isUploaded: false, ...(existingData.vascularStudies || {}) },
            dexaScan: { region: "", date: "", isUploaded: false, ...(existingData.dexaScan || {}) },
            myelogram: { region: "", date: "", isUploaded: false, ...(existingData.myelogram || {}) },
            discogram: { region: "", date: "", isUploaded: false, ...(existingData.discogram || {}) },
            petScan: { region: "", date: "", isUploaded: false, ...(existingData.petScan || {}) },
            otherDiagnosticTesting: existingData.otherDiagnosticTesting || "",
            otherDiagnosticTestingDate: existingData.otherDiagnosticTestingDate || "",
            noDiagnosticTests: existingData.noDiagnosticTests || false,
            haveImageToUpload: existingData.haveImageToUpload || "",
            acupuncturist: { name: "", treatment: "", painRelief: "", date: "", isUploaded: false, ...(existingData.acupuncturist || {}) },
            neurosurgeon: { name: "", treatment: "", painRelief: "", date: "", isUploaded: false, ...(existingData.neurosurgeon || {}) },
            chiropractor: { name: "", treatment: "", painRelief: "", date: "", isUploaded: false, ...(existingData.chiropractor || {}) },
            orthopedicSurgeon: { name: "", treatment: "", painRelief: "", date: "", isUploaded: false, ...(existingData.orthopedicSurgeon || {}) },
            rheumatologist: { name: "", treatment: "", painRelief: "", date: "", isUploaded: false, ...(existingData.rheumatologist || {}) },
            internist: { name: "", treatment: "", painRelief: "", date: "", isUploaded: false, ...(existingData.internist || {}) },
            physicalTherapist: { name: "", treatment: "", painRelief: "", date: "", isUploaded: false, ...(existingData.physicalTherapist || {}) },
            neurologist: { name: "", treatment: "", painRelief: "", date: "", isUploaded: false, ...(existingData.neurologist || {}) },
            psychiatrist: { name: "", treatment: "", painRelief: "", date: "", isUploaded: false, ...(existingData.psychiatrist || {}) },
            namePreviousPain: existingData.namePreviousPain || "",
            physiciansHaveSeen: existingData.physiciansHaveSeen || "",
            takingBloodThinner: existingData.takingBloodThinner || "",
            nameBloodThinner: existingData.nameBloodThinner || "",
            currentMedicationInfo: existingData.currentMedicationInfo || [],
            haveYouEveryDiagnosed: existingData.haveYouEveryDiagnosed || "",
            dementiaAlzheimers: existingData.dementiaAlzheimers || "",
            pregnant: existingData.pregnant || "",
            cancerType: existingData.cancerType || "",
            diabetesType: existingData.diabetesType || "",
            diabetesControlled: existingData.diabetesControlled || "",
            bloodSugarWeekly: existingData.bloodSugarWeekly || "",
            HBALC: existingData.HBALC || "",
            diabetesComorbidity: existingData.diabetesComorbidity || "",
            medicationAllergies: existingData.medicationAllergies || "",
            medicationAllergiesText: existingData.medicationAllergiesText || "",
            headEarsEyesNoseThroat: existingData.headEarsEyesNoseThroat || [],
            hematologic: existingData.hematologic || [],
            musculoskeletalRheumatologic: existingData.musculoskeletalRheumatologic || [],
            cardiovascular: existingData.cardiovascular || [],
            respiratory: existingData.respiratory || [],
            gastrointestinal: existingData.gastrointestinal || [],
            neuropsychological: existingData.neuropsychological || [],
            urological: existingData.urological || [],
            general: existingData.general || [],
            respiratoryReview: existingData.respiratoryReview || [],
            gastrointestinalReview: existingData.gastrointestinalReview || [],
            musculoskeletalReview: existingData.musculoskeletalReview || [],
            genitourinaryNephrology: existingData.genitourinaryNephrology || [],
            neurologicalReview: existingData.neurologicalReview || [],
            psychiatricReview: existingData.psychiatricReview || [],
            constitutional: existingData.constitutional || [],
            ENT: existingData.ENT || [],
            eyes: existingData.eyes || [],
            allOtherReviewNegative: existingData.allOtherReviewNegative || "",
            allOtherReviewNegativeText: existingData.allOtherReviewNegativeText || "",
            relationshipStatus: existingData.relationshipStatus || "",
            NoOfChildrens: existingData.NoOfChildrens || "",
            occupation: existingData.occupation || "",
            lastTimeWorked: existingData.lastTimeWorked || "",
            currentHousehold: existingData.currentHousehold || "",
            stairsInHouse: existingData.stairsInHouse || "",
            employmentDisability: existingData.employmentDisability || "",
            employmentDisabilityDateStarted: existingData.employmentDisabilityDateStarted || "",
            alcoholUse: existingData.alcoholUse || "",
            tobaccoUse: existingData.tobaccoUse || "",
            tobaccoUseYears: existingData.tobaccoUseYears || "",
            tobaccoUsePacksPerDay: existingData.tobaccoUsePacksPerDay || "",
            tobaccoUseQuitDate: existingData.tobaccoUseQuitDate || "",
            illegalDrugUse: existingData.illegalDrugUse || "",
            illegalDrugUseDetails: existingData.illegalDrugUseDetails || "",
            prescriptionNarcoticAbuse: existingData.prescriptionNarcoticAbuse || "",
            transfusionGraftHistory: existingData.transfusionGraftHistory || [],
            familyHistory: existingData.familyHistory || [],
            familyHistoryOtherText: existingData.familyHistoryOtherText || "",
            MRI_FILE: normalizeInvestigationFieldFromApi(existingData.MRI_FILE),
            CT_SCAN_FILE: normalizeInvestigationFieldFromApi(existingData.CT_SCAN_FILE),
            X_RAYS_FILE: normalizeInvestigationFieldFromApi(existingData.X_RAYS_FILE),
            EMG_NCV_FILE: normalizeInvestigationFieldFromApi(existingData.EMG_NCV_FILE),
            VASCULAR_STUDIES_FILE: normalizeInvestigationFieldFromApi(existingData.VASCULAR_STUDIES_FILE),
            DEXA_SCAN_FILE: normalizeInvestigationFieldFromApi(existingData.DEXA_SCAN_FILE),
            MYELOGRAM_FILE: normalizeInvestigationFieldFromApi(existingData.MYELOGRAM_FILE),
            DISCOGRAM_FILE: normalizeInvestigationFieldFromApi(existingData.DISCOGRAM_FILE),
            PET_SCAN_FILE: normalizeInvestigationFieldFromApi(existingData.PET_SCAN_FILE),
            acupuncturist_FILE: normalizeInvestigationFieldFromApi(existingData.acupuncturist_FILE),
            neurosurgeon_FILE: normalizeInvestigationFieldFromApi(existingData.neurosurgeon_FILE),
            chiropractor_FILE: normalizeInvestigationFieldFromApi(existingData.chiropractor_FILE),
            orthopedic_FILE: normalizeInvestigationFieldFromApi(existingData.orthopedic_FILE),
            rheumatologist_FILE: normalizeInvestigationFieldFromApi(existingData.rheumatologist_FILE),
            internist_FILE: normalizeInvestigationFieldFromApi(existingData.internist_FILE),
            physical_FILE: normalizeInvestigationFieldFromApi(existingData.physical_FILE),
            neurologist_FILE: normalizeInvestigationFieldFromApi(existingData.neurologist_FILE),
            psychiatrist_FILE: normalizeInvestigationFieldFromApi(existingData.psychiatrist_FILE),
          });
          setSelectedLocation(
            loadedPainAreas.map((a) => a?.title).filter(Boolean)
          );
          setSelectedLocationMulti(loadedPainAreas);
          const locked = !!existingData.finalSubmittedAt;
          setIsFormLocked(locked);
          if (locked) {
            clearFormDraft(id);
          }
          console.log("Loaded form data from API:", existingData);
        } else {
          setIsFormLocked(false);
          // No questionnaire in API yet — only restore a draft saved for THIS appointment
          const draft = loadFormDraft(id);
          if (draft) {
            setPatientMedicationInfo((prev) => ({ ...prev, ...draft }));
            console.log("Loaded form draft from local storage for this appointment");
          }
        }
      } catch (error) {
        console.error("Error fetching form data:", error);
        const draft = loadFormDraft(id);
        if (draft) {
          setPatientMedicationInfo((prev) => ({ ...prev, ...draft }));
          console.log("Loaded form draft from local storage (after API error)");
        }
      }
    };

    fetchExistingFormData();
  }, [id]);

  /** Persist to server (MongoDB). Save/Exit = progress only (no emails). Submit = full submission + emails. */
  const persistForm = async ({ saveProgressOnly }) => {
    if (isFormLockedRef.current) return;
    if (isSubmitting) return;

    if (!id || id.trim() === "") {
      alert("Error: Missing appointment ID. Please access the form through a valid appointment link.");
      console.error("Appointment ID is missing from URL");
      return;
    }

    setIsSubmitting(true);

    try {
      saveFormDraft(id, {
        ...patientMedicationInfo,
        appointmentId: id,
      });
      console.log("✅ Form draft saved locally for this appointment");
    } catch (localStorageError) {
      console.error("Error saving to localStorage:", localStorageError);
      setIsSubmitting(false);
      alert("Error: Failed to save form data locally. Please try again.");
      return;
    }

    try {
      await submitQuestionary(
        {
          ...patientMedicationInfo,
          appointmentId: id,
        },
        { saveProgressOnly }
      );
      return;
    } catch (error) {
      console.error("Error saving form to backend:", error);
      setIsSubmitting(false);
      alert(
        "We could not save your form to the server. Your answers are still stored in this browser. " +
          "Check your connection and try Save / Exit or Submit again."
      );
    }
  };

  return (
    <>
      <head>
        <title>Second Opinion</title>
      </head>
      <Navbar />
      <div className="absolute flex 2xl:hidden xl:hidden lg:hidden md:hidden top-[11%] z-50 left-0 bg-white">
        <button
          onClick={() => {
            setIsSideBarOpen(true);
          }}
          className="p-2 rounded-md cursor-pointer"
        >
          <Menu />
        </button>
      </div>

      <div className="w-full  h-[90vh] flex justify-center items-center relative">
        <aside className="bg-[#d4d4d4]/20 relative z-10 w-[20%] h-full shrink-0 p-4 overflow-y-auto hideScrollbar hidden 2xl:flex xl:flex lg:flex md:flex ">
          <div className="flex justify-start gap-3 w-full flex-wrap relative z-40 py-5 ">
            <button
              onClick={() => setCurrentStep(0)}
              className={`w-full text-start text-[1vw] font-[500]   hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-mainFont btnGraiden flex justify-start items-center gap-2 ${
                currentStep === 0
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <PatientParticularsIcon />
              Enter Patient Particulars
            </button>
            <button
              onClick={() => setCurrentStep(1)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all duration-300 ease-linear  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2  font-mainFont btnGraiden ${
                currentStep === 1
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <PainLocationIcon />
              Pain Location
            </button>
            <button
              onClick={() => setCurrentStep(2)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 2
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <PainLevel />
              Choose Pain Level
            </button>
            <button
              onClick={() => setCurrentStep(3)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 3
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <OriginOfPainIcon />
              Origin of the pain
            </button>
            <button
              onClick={() => setCurrentStep(4)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 4
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <PainCharacteristicsIcon />
              Pain Characteristics
            </button>
            <button
              onClick={() => setCurrentStep(5)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-1.5 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 5
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <RelivingFactorIcon />
              Aggravating and relieving factors..
            </button>
            <button
              onClick={() => setCurrentStep(6)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 6
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <SymptomsIcon />
              Associated Symptoms
            </button>
            <button
              onClick={() => setCurrentStep(7)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 7
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <DisablilityPainIcon />
              Disability due to pain
            </button>
            <button
              onClick={() => setCurrentStep(8)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 8
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <FunctionalScoringIcon />
              Functional Scoring
            </button>
            <button
              onClick={() => setCurrentStep(9)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 9
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <MedicationForPainIcon />
              Medications for pain
            </button>

            <button
              onClick={() => {
                setIsOpen({
                  tabName: "Pain Treatment History",
                  state: !isOpen.state,
                });
              }}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all   px-3.5 py-2 line-clamp-1  font-mainFont btnGraiden bg-transparent text-black `}
            >
              <div className="flex justify-start items-center gap-2">
                <PainTreatmentHistoryIcon />
                Pain Treatment History
              </div>
              <motion.div
                initial={{
                  opacity: 0,
                  height: "0dvh",
                  display: "none",
                }}
                animate={
                  isOpen.state && isOpen.tabName === "Pain Treatment History"
                    ? {
                        opacity: 1,
                        height: "15dvh",
                        display: "flex",
                      }
                    : { opacity: 0, height: "0dvh" }
                }
                transition={{
                  duration: 0.6,
                  ease: "circInOut",
                }}
                className="my-4 px-3 flex flex-col justify-center items-center gap-1"
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentStep(10);
                  }}
                  className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-[400] font-mainFont btnGraiden ${
                    currentStep === 10
                      ? "text-white BTNGradientBg"
                      : "bg-transparent text-black"
                  }`}
                >
                  Pain Treatment History 1
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentStep(11);
                  }}
                  className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-[400] font-mainFont btnGraiden ${
                    currentStep === 11
                      ? "text-white BTNGradientBg"
                      : "bg-transparent text-black"
                  }`}
                >
                  Pain Treatment History 2
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentStep(12);
                  }}
                  className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-[400] font-mainFont btnGraiden ${
                    currentStep === 12
                      ? "text-white BTNGradientBg"
                      : "bg-transparent text-black"
                  }`}
                >
                  Pain Treatment History 3
                </button>
              </motion.div>
            </button>

            <button
              onClick={() => {
                setIsOpen({
                  tabName: "Investigations History",
                  state: !isOpen.state,
                });
              }}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all px-3.5 py-2 line-clamp-1  font-mainFont btnGraiden 
                
                   
                bg-transparent text-black              `}
            >
              <div className="flex justify-start items-center gap-2">
                <InvestigationsHistoryIcon />
                Investigations History
              </div>
              <motion.div
                initial={{
                  opacity: 0,
                  height: "0dvh",
                  display: "none",
                }}
                animate={
                  isOpen.state && isOpen.tabName === "Investigations History"
                    ? {
                        opacity: 1,
                        height: "10dvh",
                        display: "flex",
                      }
                    : { opacity: 0, height: "0dvh" }
                }
                transition={{
                  duration: 0.6,
                  ease: "circInOut",
                }}
                className="my-4 px-3 flex flex-col justify-center items-center gap-1"
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentStep(13);
                  }}
                  className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-[400] font-mainFont btnGraiden ${
                    currentStep === 13
                      ? "text-white BTNGradientBg"
                      : "bg-transparent text-black"
                  }`}
                >
                  Investigations History 1
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentStep(14);
                  }}
                  className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-[400] font-mainFont btnGraiden ${
                    currentStep === 14
                      ? "text-white BTNGradientBg"
                      : "bg-transparent text-black"
                  }`}
                >
                  Investigations History 2
                </button>
              </motion.div>
            </button>

            <button
              onClick={() => setCurrentStep(15)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 15
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <CurrentMedicationIcon />
              Current Medications
            </button>
            <button
              onClick={() => setCurrentStep(16)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 16
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <PastMedicalHistoryIcon />
              Past Medical History
            </button>
            <button
              onClick={() => setCurrentStep(17)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2  font-mainFont btnGraiden ${
                currentStep === 17
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <SystemForTodayIcon />
              Review of systems for today
            </button>
            <button
              onClick={() => setCurrentStep(18)}
              className={`text-[1vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 18
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <SocialHistoryIcon />
              Social History
            </button>
          </div>
        </aside>
        <div className="flex-1 h-full overflow-y-auto hideScrollbar shrink-0 relative z-10  border-l-2 border-[#d4d4d4]/30 p-1">
          {/* top progress bar */}
          <div className="w-full mx-auto my-4 py-4 px-2 flex flex-col gap-5">
            <ProgressBar
              title={allForms[currentStep].title}
              subtitle={allForms[currentStep].subtitle}
              currentStep={currentStep}
              steps={allForms}
              progressAsFormFilled={progress}
            />
          </div>

          <div className="bg-baseColo flex-1 2xl:p-6 xl:p-6  lg:p-6 md:p-4 p-3 rounded-lg shadow-mds relative">
            {isFormLocked && (
              <div
                className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-950"
                role="status"
              >
                You have submitted this questionnaire. It is read-only. You can
                use the steps or sidebar to review your answers.
              </div>
            )}
            {/* <div className="absolute top-0 -left-[20vw] w-[40%] h-full gradientBg" /> */}
            <fieldset
              disabled={isFormLocked}
              className="min-w-0 border-0 p-0 m-0"
            >
              <div className="relative z-20">{renderCurrentForm()}</div>
            </fieldset>

            {/* the nav btns  */}
            <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between items-center 2xl:gap-10 xl:gap-10 lg:gap-10 md:gap-10 gap-3 mt-10">
              <PreviousButton
                handlePrevious={handlePrevious}
                disabled={currentStep <= 0 ? true : false}
              />
              {currentStep === allForms.length - 1 ? (
                <></>
              ) : (
                <>
                  <NextButton handleNext={handleNext} />
                </>
              )}
              {!isFormLocked && currentStep === allForms.length - 1 && (
                <button
                  onClick={() => persistForm({ saveProgressOnly: false })}
                  disabled={isSubmitting}
                  type="button"
                  className={`flex justify-center items-center gap-3 shadowBTs BTNGradientBg text-baseColor 2xl:px-7 xl:px-7 lg:px-7 md:px-7 px-5 py-2 rounded-full font-mainFont font-[500] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.1vw] text-[4vw] transition-all duration-150 ease-linear border-none border-[#DB9A31] forSvg place-content-center ml-auto my-5 w-full ${
                    isSubmitting ? 'opacity-75 cursor-not-allowed' : 'hover:opacity-90'
                  }`}
                >
                  {isSubmitting ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              )}
              {/* Save / Exit — hidden after final submission */}
              {!isFormLocked && (
              <button
                onClick={() => persistForm({ saveProgressOnly: true })}
                disabled={isSubmitting}
                type="button"
                className={`flex justify-center items-center gap-3 shadowBTs BTNGradientBg text-baseColor 2xl:px-7 xl:px-7 lg:px-7 md:px-7 px-5 py-2 rounded-full font-mainFont font-[500] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.1vw] text-[3.5vw] transition-all duration-150 ease-linear border-none border-[#ff7537] forSvg ml-auto w-full ${
                  isSubmitting ? 'opacity-75 cursor-not-allowed' : 'hover:opacity-90'
                }`}
                style={{ display: 'flex' }} // Ensure it's always visible
              >
                {isSubmitting ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                    Submitting...
                  </>
                ) : (
                  "Save / Exit"
                )}
              </button>
              )}
            </div>
          </div>
        </div>

        {/* <div className="w-full h-full absolute top-0 left-0 opacity-25 overflow-hidden">
          <img src={CellParttenBg} className="w-full h-full object-cover " />
        </div> */}
      </div>

      {isSideBarOpen && (
        <SideBar
          setIsSideBarOpen={setIsSideBarOpen}
          setCurrentStep={setCurrentStep}
          currentStep={currentStep}
          setIsOpen={setIsOpen}
          isOpen={isOpen}
        />
      )}
    </>
  );
};

const SideBar = ({
  setIsSideBarOpen,
  setCurrentStep,
  currentStep,
  setIsOpen,
  isOpen,
}) => {
  return (
    <>
      <div className="bg-white fixed z-50 top-0 left-0 w-full h-[100vh] overflow-y-auto">
        <div className="w-full justify-end items-center flex p-3">
          <button onClick={() => setIsSideBarOpen(false)} className="ml-auto">
            <X />
          </button>
        </div>

        <aside className=" relative z-10 w-[80%] h-full shrink-0 p-4 overflow-y-auto hideScrollbar flex  2xl:hidden xl:hidden lg:hidden md:hidden ">
          <div className="flex justify-start gap-3 w-full flex-wrap relative z-40 py-5 ">
            <button
              onClick={() => {
                setCurrentStep(0);
                setIsSideBarOpen(false);
              }}
              className={`w-full text-start 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500]   hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-mainFont btnGraiden flex justify-start items-center gap-2 ${
                currentStep === 0
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <PatientParticularsIcon />
              Enter Patient Particulars
            </button>
            <button
              onClick={() => {
                setCurrentStep(1);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all duration-300 ease-linear  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2  font-mainFont btnGraiden ${
                currentStep === 1
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <PainLocationIcon />
              Pain Location
            </button>
            <button
              onClick={() => {
                setCurrentStep(2);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 2
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <PainLevel />
              Choose Pain Level
            </button>
            <button
              onClick={() => {
                setCurrentStep(3);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 3
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <OriginOfPainIcon />
              Origin of the pain
            </button>
            <button
              onClick={() => {
                setCurrentStep(4);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 4
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <PainCharacteristicsIcon />
              Pain Characteristics
            </button>
            <button
              onClick={() => {
                setCurrentStep(5);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-1.5 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 5
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <RelivingFactorIcon />
              Aggravating and relieving factors..
            </button>
            <button
              onClick={() => {
                setCurrentStep(6);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 6
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <SymptomsIcon />
              Associated Symptoms
            </button>
            <button
              onClick={() => {
                setCurrentStep(7);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 7
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <DisablilityPainIcon />
              Disability due to pain
            </button>
            <button
              onClick={() => {
                setCurrentStep(8);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 8
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <FunctionalScoringIcon />
              Functional Scoring
            </button>
            <button
              onClick={() => {
                setCurrentStep(9);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 9
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <MedicationForPainIcon />
              Medications for pain
            </button>

            <button
              onClick={() => {
                setIsOpen({
                  tabName: "Pain Treatment History",
                  state: !isOpen.state,
                });
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all   px-3.5 py-2 line-clamp-1  font-mainFont btnGraiden bg-transparent text-black `}
            >
              <div className="flex justify-start items-center gap-2">
                <PainTreatmentHistoryIcon />
                Pain Treatment History
              </div>
              <motion.div
                initial={{
                  opacity: 0,
                  height: "0dvh",
                  display: "none",
                }}
                animate={
                  isOpen.state && isOpen.tabName === "Pain Treatment History"
                    ? {
                        opacity: 1,
                        height: "15dvh",
                        display: "flex",
                      }
                    : { opacity: 0, height: "0dvh" }
                }
                transition={{
                  duration: 0.6,
                  ease: "circInOut",
                }}
                className="my-4 px-3 flex flex-col justify-center items-center gap-1"
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentStep(10);
                    setIsSideBarOpen(false);
                  }}
                  className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-[400] font-mainFont btnGraiden ${
                    currentStep === 10
                      ? "text-white BTNGradientBg"
                      : "bg-transparent text-black"
                  }`}
                >
                  Pain Treatment History 1
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentStep(11);
                    setIsSideBarOpen(false);
                  }}
                  className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-[400] font-mainFont btnGraiden ${
                    currentStep === 11
                      ? "text-white BTNGradientBg"
                      : "bg-transparent text-black"
                  }`}
                >
                  Pain Treatment History 2
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentStep(12);
                    setIsSideBarOpen(false);
                  }}
                  className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-[400] font-mainFont btnGraiden ${
                    currentStep === 12
                      ? "text-white BTNGradientBg"
                      : "bg-transparent text-black"
                  }`}
                >
                  Pain Treatment History 3
                </button>
              </motion.div>
            </button>

            <button
              onClick={() => {
                setIsOpen({
                  tabName: "Investigations History",
                  state: !isOpen.state,
                });
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all px-3.5 py-2 line-clamp-1  font-mainFont btnGraiden 
                
                   
                bg-transparent text-black              `}
            >
              <div className="flex justify-start items-center gap-2">
                <InvestigationsHistoryIcon />
                Investigations History
              </div>
              <motion.div
                initial={{
                  opacity: 0,
                  height: "0dvh",
                  display: "none",
                }}
                animate={
                  isOpen.state && isOpen.tabName === "Investigations History"
                    ? {
                        opacity: 1,
                        height: "10dvh",
                        display: "flex",
                      }
                    : { opacity: 0, height: "0dvh" }
                }
                transition={{
                  duration: 0.6,
                  ease: "circInOut",
                }}
                className="my-4 px-3 flex flex-col justify-center items-center gap-1"
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentStep(13);
                    setIsSideBarOpen(false);
                  }}
                  className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-[400] font-mainFont btnGraiden ${
                    currentStep === 13
                      ? "text-white BTNGradientBg"
                      : "bg-transparent text-black"
                  }`}
                >
                  Investigations History 1
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentStep(14);
                    setIsSideBarOpen(false);
                  }}
                  className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 font-[400] font-mainFont btnGraiden ${
                    currentStep === 14
                      ? "text-white BTNGradientBg"
                      : "bg-transparent text-black"
                  }`}
                >
                  Investigations History 2
                </button>
              </motion.div>
            </button>

            <button
              onClick={() => {
                setCurrentStep(15);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 15
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <CurrentMedicationIcon />
              Current Medications
            </button>
            <button
              onClick={() => {
                setCurrentStep(16);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 16
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <PastMedicalHistoryIcon />
              Past Medical History
            </button>
            <button
              onClick={() => {
                setCurrentStep(17);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2  font-mainFont btnGraiden ${
                currentStep === 17
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <SystemForTodayIcon />
              Review of systems for today
            </button>
            <button
              onClick={() => {
                setCurrentStep(18);
                setIsSideBarOpen(false);
              }}
              className={`2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[500] w-full text-start hoverEffectBTN transition-all  rounded-md px-3.5 py-2 line-clamp-1 flex justify-start items-center gap-2 font-mainFont btnGraiden ${
                currentStep === 18
                  ? "text-white BTNGradientBg"
                  : "bg-transparent text-black"
              }`}
            >
              <SocialHistoryIcon />
              Social History
            </button>
          </div>
        </aside>
      </div>
    </>
  );
};
